import React, { useState, useEffect, useRef } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Modal, Skeleton, Button, Alert } from "antd";
import DOMPurify from "dompurify";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import PrintPaper from "@general/printPaper";
const GETCONTRACT = gql`
  query ($id: ID!) {
    getCard(id: $id) {
      contract
      createdAt
    }
  }
`;
function AdminCardContract({ id }) {
  const [contract, setContract] = useState({});
  const [signDate, setSignDate] = useState();
  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onBeforeGetContent: async () => {
      await document.fonts.ready;
      try {
        await document.fonts.load('18px IRANSansXFaNum');
      } catch (e) {
        console.warn('font load failed', e);
      }
    },
    pageStyle: `
    @font-face {
      font-family: "IRANSansXFaNum";
      src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
    }
    .contract-wrapper,
    .contract-wrapper * {
      font-family: "IRANSansXFaNum" !important;
    }
  `,
  });


  const [getContractlData, contractData] = useLazyQuery(GETCONTRACT, {
    fetchPolicy: "no-cache",
    onError(error) {
      console.log(error.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
    onCompleted({ getCard }) {
      const { contract, createdAt } = getCard;
      setContract(contract);
      setSignDate(createdAt);
    },
  });
  useEffect(() => {
    if (id) {
      getContractlData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  if (contractData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (!contract)
    return (
      <>
        <Alert
          message="این کاربر تعهدنامه امضا شده ندارد"
          type="warning"
          showIcon
        />
      </>
    );
  return (
    <>

      <Button type="primary" icon={<PrinterOutlined />} onClick={reactToPrintFn}>
        چاپ تعهدنامه 
      </Button>
      <PrintPaper html={contract} ref={contentRef}>
        <span>
          امضا شده در تاریخ {moment(signDate).format("jYYYY/jMM/jDD")} به صورت
          آنلاین توسط کاربر
        </span>
      </PrintPaper>
    </>
  );
}

export default AdminCardContract;
